<template>
	<section id="main_index">
		<div id="main">
			<div class="main_visual">
				<div class="visual_bg">
					<div class="visual_element">
						<img src="/img/main/main_visual_element.png" loading="lazy">
					</div>
				</div>
			</div>

			<div class="logo" @click="goto_home">
				<img src="/img/common/logo_w.png" alt="로고">
			</div>
			<div class="mlogo" @click="goto_home">
				<img src="/img/common/logo.png" alt="로고">
			</div>

			<div class="login">
				<div class="login_box">
					<h3 class="login_tit"><span>덴탈클라우드</span> 로그인</h3>

					<form ref="form_login" id="form_login" :action="`${SERVER_URL}/api/app/auth/login`" @submit.prevent="login_submit()" method="post">
						<div class="input_login">
							<input type="text" name="mb_id" id="login_id" v-model="form.mb_id" placeholder="아이디" required />
						</div>
						<div class="input_password">
							<input type="password" name="mb_password" id="login_pw" autocomplete="on" v-model="form.mb_password" placeholder="비밀번호" @keyup.enter.prevent="login_submit()" required />
						</div>
						<button type="button" class="login_btn main_btn" @click="login_submit">
							로그인
						</button>
						<div class="login_option">
							<div class="mainSearchBtn">
								<div class="search_pw" @click="commonjs.pagePopup('/lost_idpw', 'lost_idpw')">
									아이디/비밀번호 찾기
								</div>
							</div>
						</div>
					</form>
				</div>
				<div class="join_btn main_btn" @click="goto_register">회원가입</div>
				<div class="join_btn main_btn mjoin_btn" @click="goto_register">회원가입</div>
			</div>
		</div>
	</section>

	<include-footer />
</template>

<script>
import footer from '../components/layout/footer.vue'

export default {
	name: 'App',
	components: {
		'include-footer': footer
	}
}
</script>

<script setup>
import { env as SERVER_URL } from '@/components/utils/env';
import { onMounted, ref, computed, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import * as globaljs from '@/components/utils/global';
import * as commonjs from '@/components/utils/common';

const route = useRoute();
const router = useRouter();

let submitingFlag = false; // 플래그 변수
const withSubmitFlag = async (asyncFunc) => {
	if (submitingFlag) return; // 요청 중복 방지
		submitingFlag = true; // 요청 시작 시 플래그 설정
	try {
		await asyncFunc(); // 비동기 함수 실행
	} finally {
		submitingFlag = false; // 요청이 끝나면 플래그 해제
	}
};

const form = ref({
	mb_id: "",
	mb_password: "",
});

const goto_home = () => {
	router.push('/');
};

const openPasswordLost = () => {
	// window.open('/password_lost', 'win_password_lost', 'left=50, top=50, width=617, height=330, scrollbars=1');
};

const goto_register = () => {
	router.push('/register');
};

if (globaljs.getIsLogin()) {
	router.push('/');
}

onMounted(() => {
	commonjs.DOMLoaded();

	const link = document.createElement('link');
	link.rel = 'stylesheet';
	link.href = '/css/login.css';
	document.head.appendChild(link);
});

const logout_func = async () => {
	try {
		const response = await axios.post(`${SERVER_URL}/api/app/auth/logout`);

	} catch (error) {
console.error(error?.response?.data);
	} finally {
		// 250522_JAMONG 기능 통합
		globaljs.clearUserInfo();
	}
}

const login_submit = async () => {
	await withSubmitFlag(async () => {
		// 250522_JAMONG 기능 통합
		globaljs.clearUserInfo();

		if (!form.value.mb_id || form.value.mb_id.length < 1) {
			commonjs.formSwal('아이디', '아이디', '#login_id');
			return false;
		}
		if (!form.value.mb_password || form.value.mb_password.length < 1) {
			commonjs.formSwal('비밀번호', '비밀번호', '#login_pw');
			return false;
		}

		const formData = new URLSearchParams();
		formData.append("mb_id", form.value.mb_id);
		formData.append("mb_password", form.value.mb_password);

		try {
			const response = await axios.post(`${SERVER_URL}/api/app/auth/login`, formData);
			if (response?.data?.result && response?.data?.result?.status !== 401) {
//console.debug('login.login_submit() ', response?.data?.result);

			// 250522_JAMONG 기능 통합
			globaljs.clearUserInfo();

				let acc_type = '';
				let mb_grade = '';
				const token = response.data.result?.token;
				const mb_idx = response.data.result?.id;
				const mb_id = response.data.result?.member?.mb_id;
				const mb_name = response.data.result?.member?.mb_name;
				const mb_nick = response.data.result?.member?.mb_nick;
				const mb_level = response.data.result?.member?.mb_level ?? 0;
				const mb_boss_id = response.data.result?.member?.mb_boss_id || null;
				let mb_staff = response.data.result?.member?.mb_staff || null;

				if (mb_level === 4 || mb_level === 5) {
					acc_type = 'lab';
					if (mb_level === 5) {
						mb_grade = 'first';
					} else {
						mb_grade = 'second';
					}
				} else if (mb_level === 2 || mb_level === 3) {
					acc_type = 'hospital';
					if (mb_level === 3) {
						mb_grade = 'first';
					} else {
						mb_grade = 'second';
					}
				}

				globaljs.safeSetItem('token', String(token));
				globaljs.safeSetItem('mb_idx', mb_idx);
				globaljs.safeSetItem('mb_id', mb_id);
				globaljs.safeSetItem('mb_name', mb_name);
				globaljs.safeSetItem('mb_nick', mb_nick);
				globaljs.safeSetItem('mb_level', Number(mb_level));
				globaljs.safeSetItem('mb_boss_id', mb_boss_id);
				// mb_staff가 null이 아니고 JSON 형식의 문자열인지 확인하여 처리
				if (mb_staff !== null && typeof mb_staff === 'string' && (mb_staff.startsWith('{') || mb_staff.startsWith('['))) {
					try {
						mb_staff = JSON.parse(mb_staff);
						globaljs.safeSetItem('mb_staff', JSON.stringify(mb_staff)); // 객체로 저장하기 위해 문자열로 변환
					} catch (error) {
						console.error('JSON 파싱 오류:', error);
						globaljs.safeSetItem('mb_staff', mb_staff); // 파싱에 실패해도 원본 값 저장
					}
				} else {
					globaljs.safeSetItem('mb_staff', mb_staff); // 단순 문자열이거나 null인 경우
				}

				globaljs.safeSetItem('acc_type', acc_type);
				globaljs.safeSetItem('mb_grade', mb_grade);

				globaljs.setAuthToken(token);

				// 250522_JAMONG 기능 통합
				globaljs.setUserInfo({
					mb_idx: mb_idx,
					mb_id: mb_id,
					mb_name: mb_name,
					mb_nick: mb_nick,
					mb_level: mb_level,
					mb_boss_id: mb_boss_id,
					mb_staff: mb_staff,
					acc_type: acc_type,
					mb_grade: mb_grade,
				});


				if ((globaljs.safeGetItem('mb_level') ?? 0) === 1) {
					Swal.fire({
						title: '승인 대기 중',
						html: `<div style="word-break: keep-all;">관리자 승인 완료 후, 서비스 이용이 가능합니다.</div>`,
						icon: 'warning',
						confirmButtonText: '확인',
						allowOutsideClick: false,  // 외부 클릭 방지
						allowEscapeKey: false,      // ESC 키 눌러서 닫기 방지
						returnFocus: false,
					}).then(async (result) => {
						if (result.isConfirmed) {
							//await router.push('/logout');
							await logout_func();
						}
					});
				} else if ((globaljs.safeGetItem('mb_level') ?? 0) === 0) {
					Swal.fire({
						title: '승인이 반려됨',
						html: `<div style="word-break: keep-all;">가입승인이 반려된 회원은 서비스를 이용할수 없습니다.</div>`,
						icon: 'warning',
						confirmButtonText: '확인',
						allowOutsideClick: false,  // 외부 클릭 방지
						allowEscapeKey: false,      // ESC 키 눌러서 닫기 방지
						returnFocus: false,
					}).then(async (result) => {
						if (result.isConfirmed) {
							//await router.push('/logout');
							await logout_func();
						}
					});
				} else {
					toast.fire({
						icon: "success",
						title: "로그인 성공!"
					});

					await router.push("/");
				}
			} else {
				toast.fire({
					icon: "error",
					title: response?.data?.result?.message
				});
			}
		} catch (error) {
	console.error(error?.response?.data);
			toast.fire({
				icon: "error",
				title: error?.response?.data?.result?.message
			});
		}
	});
};
</script>